exports.ucs2 = {};
exports.encode = exports.decode =
exports.ucs2.encode = exports.ucs2.decode =
exports.toUnicode = exports.toASCII =
function (s) { return s };
exports.version = "0.0.0";


//////////////////
// WEBPACK FOOTER
// (webpack)/~/node-libs-browser/mock/punycode.js
// module id = 1912
// module chunks = 0